// extracted by mini-css-extract-plugin
export default {"alerts":"MainAlertAndLoading_alerts__KgDTz","loadingWrapper":"MainAlertAndLoading_loadingWrapper__c4YKg"};